export default class MapMaker {

	static createDynamicMap(element) {

		let map = new google.maps.Map(element, {
			zoom: 10,
			clickableIcons: false,
			streetViewControl: false,
			mapTypeControl: false,
			fullscreenControl: false,
			gestureHandling: "cooperative",
			mapId: skArgs.gmapMapId
		});

		map.bounds = new google.maps.LatLngBounds();
		map.markers = [];

		return map;
	}

	static createStaticMap(element, markers) {

		let imgWidth = "640";
		let imgHeight = "640";
		if (element.classList.contains('map-fullwidth')) {
			imgHeight = "360";
		}

		let url = "https://maps.googleapis.com/maps/api/staticmap?";
		url += "key=" + skArgs.gmapApiKey;
		url += "&map_id=" + skArgs.gmapMapId;
		url += "&size=" + imgWidth + "x" + imgHeight;
		url += "&scale=2";
		url += "&format=JPEG";

		if (markers.length === 1) {
			url += "&center=" + markers[0].dataset.markerLat + "," + markers[0].dataset.markerLng;
			url += "&zoom=" + element.dataset.zoom;
		}

		markers.forEach((marker) => {
			url += "&markers=";
			url += marker.dataset.markerLat + "," + marker.dataset.markerLng;
			if (marker.dataset.pointer) {
				url += "|icon:" + encodeURI(marker.dataset.pointer);
			}
		});

		let image = new Image();
		image.src = url;
		image.width = imgWidth;
		image.height = imgHeight;
		element.appendChild(image);

	}

	static createMarker(marker, map) {

		const icon = document.createElement('div');
		icon.classList.add("map-icon");
		icon.classList.add("theme-" + marker.dataset.theme);
		icon.innerHTML = `
			<svg width="22" height="27" viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path class="pointer-color" d="M17.9568 3.92605C13.9031 -0.112794 7.65602 0.172216 3.91234 3.90227C0.12109 7.67985 -0.0697141 13.9996 3.93621 17.9912L10.9699 25L18.0281 17.9673C21.7002 14.3086 22.2963 8.25024 17.9567 3.92615L17.9568 3.92605Z" fill="#FF8264"/>
				<path d="M3.55957 3.54785C7.36699 -0.245522 13.6452 -0.647581 17.9043 3.1875L18.3096 3.57227L18.6201 3.88184L18.6133 3.88965C22.8297 8.4024 22.1429 14.573 18.3809 18.3213L11.3232 25.3545L10.9697 25.7061L10.6172 25.3545L3.58301 18.3457C-0.624478 14.1533 -0.422302 7.51537 3.55957 3.54785Z" stroke="white" stroke-opacity="0.7"/>
			</svg>`;

		let m = new google.maps.marker.AdvancedMarkerElement({
			// id: marker.dataset.index,
			map: map,
			position: {
				lat: parseFloat(marker.dataset.markerLat),
				lng: parseFloat(marker.dataset.markerLng)
			},
			content: icon
		});

		m.markerId = marker.dataset.index;

		let infoWindow = new google.maps.InfoWindow();

		m.addEventListener('mouseenter', () => {
			icon.classList.add("active");
			document.querySelector('.card-program[data-index="' + marker.dataset.index + '"]').classList.add('active');
		});

		m.addEventListener('mouseleave', () => {
			icon.classList.remove("active");
			document.querySelector('.card-program[data-index="' + marker.dataset.index + '"]').classList.remove('active');
		});

		m.addListener('gmp-click', () => {
			if (this.activeInfoWindow) {
				this.activeInfoWindow.close();
			}

			const title = marker.querySelector(".marker-name").innerText;
			const subtitle = marker.querySelector(".marker-subtitle").innerText;
			const moreInfo = marker.querySelector(".marker-info").outerHTML;

			infoWindow.setContent(`
						<div class="map-tooltip-content">
							<div class="rich-text">
								<div class="title-level-3 m-0">${title}</div>
								<p>${subtitle}</p>
								${moreInfo}	
							</div>						
						</div>
					`);
			infoWindow.open(map, m);
			this.activeInfoWindow = infoWindow;
		});

		map.markers.push(m);
		map.bounds.extend(m.position);
	}

	static updateBounds(map) {
		const bounds = new google.maps.LatLngBounds();
		let hasVisibleMarkers = false;
		map.markers.forEach((marker) => {
			const isVisible = marker.map !== null && marker.content.style.display !== 'none';
			if (isVisible) {
				bounds.extend(marker.position);
				hasVisibleMarkers = true;
			}
		});

		if (hasVisibleMarkers) {
			map.fitBounds(bounds);
			// s'il n'y a qu'un seul marqueur
			const listener = google.maps.event.addListener(map, 'idle', () => {
				if (map.getZoom() > 12) map.setZoom(12);
				google.maps.event.removeListener(listener);
			});
		}
	}
}
